import React from "react"

const Content = ({ children }) => <main>{children}</main>

export default Content
